import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-382ebc04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-warp" }
const _hoisted_2 = {
  key: 0,
  class: "content-warp-item-number",
  style: {"margin-top":"-25px"}
}
const _hoisted_3 = {
  key: 1,
  class: "content-warp-item-number"
}


import { OptionData } from './type';
import { surveySvg31 } from './svg-components/index';
import { selfAdaption, dataProcessing } from './hooks';
import { onMounted, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-survey-3',
  props: {
    optionData: {}
  },
  setup(__props: any) {

const porps = __props;
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
let comps = [surveySvg31, surveySvg31, surveySvg31];
let _data = dataProcessing(porps.optionData, comps);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "survey",
    ref_key: "TaskRef",
    ref: TaskRef,
    style: _normalizeStyle({
      transform: `scale(${scale.value})`,
      transformOrigin: '0 0'
    })
  }, [
    _createElementVNode("div", {
      class: "content",
      ref_key: "ContentRef",
      ref: ContentRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_data), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "content-warp-item"
          }, [
            (index + 1 == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", null, _toDisplayString(item.data.slice(0, 2)), 1),
                  _createElementVNode("p", null, _toDisplayString(item.data.slice(2, 4)), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.data), 1)),
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.comp), {
              numbers: index + 1,
              controlColor: `var(--theme-color-${index + 1},#000)`
            }, null, 8, ["numbers", "controlColor"])),
            _createElementVNode("div", {
              style: _normalizeStyle(index + 1 == 2 ? 'width: 265px' : ''),
              class: "content-warp-item-tip"
            }, _toDisplayString(item.tipsText), 5)
          ]))
        }), 128))
      ])
    ], 512)
  ], 4))
}
}

})